import React, { useCallback, useEffect, useState } from 'react';
import BootstrapForm from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { Field, useFormikContext } from 'formik';
import { isEmpty } from 'lodash-es';

import CustomDatePicker from '../../../../../components/shared/CustomDatePicker/CustomDatePicker';
import CustomSelect from '../../../../../components/shared/CustomSelect/CustomSelect';
import CustomTextField from '../../../../../components/shared/CustomTextField/CustomTextField';
import LocationSelect from '../../../../../components/shared/Location/LocationSelect';
import { setLocationField } from '../../../../../helpers/commonHelper';

import SkillsSelect from './SkillsSelect/SkillsSelect';

import styles from './CandidateStrengthenStep2.module.scss';

const INITIAL_VALUES = {
  current_employer: false,
  current_location: false,
  current_title: false,
  diversity_hire: false,
  joining_date: false,
};

const CandidateStrengthenStep2 = ({ disableFields = false, organizationName = '' }) => {
  const { t } = useTranslation('common');
  const [disabledFields, setDisabledFields] = useState(INITIAL_VALUES);
  const { values, setValues } = useFormikContext();

  useEffect(() => {
    if (!isEmpty(values) && disableFields) {
      const newValues = { ...disabledFields };
      Object.entries(values).forEach(([key, value]) => {
        if (key === 'joining_date' && !isEmpty(String(value))) {
          newValues[key] = true;
        } else if (key === 'diversity_hire' && value) {
          newValues[key] = true;
        } else if (!isEmpty(value)) {
          newValues[key] = true;
        }
      });
      setDisabledFields(newValues);
    }
  }, []);

  const handleDateChange = useCallback((data) => {
    setValues((prevValues) => ({ ...prevValues, joining_date: data }));
  }, []);

  const handleValueChange = (event, key) => {
    setValues({ ...values, [key]: event.target.value });
  };
  return (
    <div>
      <div className={styles.formContainer}>
        <div>
          <span className={styles.questionHeading}>{t('strengthen.currentTitleQuestion')}</span>
          <Field
            name="current_title"
            as={CustomTextField}
            type="text"
            label={t('formLabels.currentTitle')}
            disabled={disabledFields.current_title}
          />
        </div>

        <div>
          <span className={styles.questionHeading}>{t('strengthen.currentEmployerQuestion')}</span>
          <Field
            name="current_employer"
            as={CustomTextField}
            type="text"
            label={t('formLabels.currentEmployer')}
            disabled={disabledFields.current_employer}
          />
        </div>

        <div>
          <span className={styles.questionHeading}>{t('strengthen.currentLocationQuestion')}</span>
          <Field
            name="current_location"
            as={LocationSelect}
            onChange={(location) => {
              setValues(setLocationField(values, location));
            }}
            showIcon={false}
            label={t('formLabels.currentLocation')}
            value={{ full_address: values.current_location }}
            disabled={disabledFields.current_location}
          />
        </div>

        <SkillsSelect />

        {organizationName === 'Connect Pediatrics' && (
          <div>
            <span className={styles.questionHeading}>{t('strengthen.certificationQuestion')}</span>
            <div className={styles.licenseMargin}>
              <Field
                name="license_available"
                as={CustomSelect}
                label={t('formLabels.licenseAvailable')}
                className="form-control"
                options={[
                  { label: t('yes'), value: 'Yes' },
                  { label: t('no'), value: 'No' },
                ]}
                data={values.license_available}
                onChange={(event) => handleValueChange(event, 'license_available')}
              />
            </div>
          </div>
        )}

        <div>
          <span className={styles.questionHeading}>{t('strengthen.soonestStartDateQuestion')}</span>
          <Field
            name="joining_date"
            as={CustomDatePicker}
            label={t('formLabels.soonestStartDate')}
            disabled={disabledFields.joining_date}
            onChange={(date) => handleDateChange(date)}
            showIcon={false}
          />
        </div>

        <div>
          <span className={styles.questionHeading}>{t('strengthen.diversityQuestion')}</span>
          <div className={styles.diversityContainer}>
            <Field
              name="diversity_hire"
              as={BootstrapForm.Check}
              isValid
              checked={values.diversity_hire}
              disabled={disabledFields.diversity_hire}
            />
            <span>{t('yes')}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateStrengthenStep2;
